import { ProviderType } from 'src/types/provider';

const checkOrChangeProvider = (
    providers: ProviderType[],
    oldProvider: ProviderType,
    key: 'ID' | 'ESHOP_KEY' | 'PUBLIC_ID',
    value: string | number
) => {
    if (value && providers && providers.length && oldProvider[key] !== value) {
        const newProvider = providers.find((provider) => provider[key] === value);

        setTimeout(() => {
            if (newProvider && newProvider.ESHOP_KEY) {
                localStorage.setItem('eshopKey', newProvider.ESHOP_KEY);
                localStorage.setItem('eshopName', newProvider.COMPANY_NAME || '');
                window.location.reload();
            }
        });
        return true;
    }

    return false;
};

export default checkOrChangeProvider;
